import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileProgressBarControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
    }
}

const mobileProgressBarControlView = new MobileProgressBarControlView();
export default mobileProgressBarControlView;